import { fontWeight, styled } from '@mui/system';
import { useContext, useEffect, useRef, useState } from 'react';
import ReactCrop from 'react-image-crop';
import {
  AgentPage,
  AgentDetail,
  UploadPhotoWrapper,
  UploadPhotoIcon,
  Input,
  InputFile,
  AgentInfoWrapper,
  AgentNameWrapper,
  AgentDetailsWrapper,
  AgentDetailsInput,
  AgentDetailExtra,
  AgentContactContainer,
  AgentContactWrapper,
  AgentContactListItem,
  AgentAdditionalDetailsContainer,
  AgentCompanyWebsite,
  AgentDetailsBio,
  AgentFooter,
  AgentH1,
  EditContainer,
  EditIcon,
  AgentOfficeAddress,
  AgentCityStateServedContainer,
  AgentCityStateServed,
  CloseIcon,
  AgentDetailsInputGroup
} from '../../components/agent';
import { INIT_DATA } from '../../components/agent/data';
import { AGENT_PROFILE_URL } from '../../constants/common';
import { getUserType } from '../../utils/common';
import { updateCommunityPhotos, getOfficers } from '../../services/admin';
import { MainContext } from '../../context';
import getCroppedImg from '../../utils/getCroppedImage';
import { Box, Dialog } from '@mui/material';
import { Button } from 'react-bootstrap';
import 'react-image-crop/dist/ReactCrop.css';
import { FieldErrorMessage } from './addagent';
import Loader from '../../components/loader';
import centerAspectCrop from '../../utils/centerAspectRatio';
import Switch from '@mui/material/Switch';
import Select from 'react-select';


export const CropperButtons = styled('div')(({ theme }) => ({
  padding: 16,
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const CropLoading = styled('div')(({ theme }) => ({
  minWidth: 500,
}));

export const SwitchContainer = styled('div')(() => ({
  display: 'flex',
  gap: 16,
  alignItems: 'center',
  '& label': {
    fontSize: 24,
    lineHeight: '36px',
    maxWidth: 150,
  },
  '& span': {
    fontSize: 30,
    fontWeight: 700,
  },
}));

const EditAgent = ({ agent, handleSubmit, isSubmitting, errors }) => {
  const imgRef = useRef(null);
  const [showEditPhoto, setShowEditPhoto] = useState(false);
  const [showUploadPhoto, setShowUploadPhoto] = useState(false);
  const [error, setError] = useState(false);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [crop, setCrop] = useState({ unit: '%', width: 50, aspect: 1 });
  const [data, setData] = useState(agent || INIT_DATA);
  const [editName, setEditName] = useState(false);
  const [cropLoading, setCropLoading] = useState(true);
  const isAdmin = getUserType() == 2;
  const { setActiveAgent } = useContext(MainContext);
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSelectChange = (name, sdata) => {
    setData({
      ...data,
      [name]: sdata,
    });
  };
  const [previewImage, setPreviewImage] = useState(agent.photo || false);
  const handleImageChange = (event) => {
    setCropLoading(true);
    const file = event.target.files[0];

    if (file) {
      setData({
        ...data,
        photo: file,
      });
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        setShowEditPhoto(true);
        setCropLoading(false);
      };
      reader.readAsDataURL(file);
    }
  };

  const [officers, setOfficers] = useState([])
  useEffect(() => {
    async function fetchOfficers() {
      const result = await getOfficers();
      setOfficers(result.results)
      if(agent.loan_officer_id) {
        setData({
          ...data,
          loan_officer: { value: agent.loan_officer_id, label: agent.loan_officer.first_name + ' '+ agent.loan_officer.last_name}
        })
      }
    }

    fetchOfficers()
  }, [])

  const {
    first_name,
    last_name,
    brokerage,
    company_website,
    personal_website,
    company_phone,
    mobile_phone,

    description,
    // eslint-disable-next-line no-unused-vars
    photo,
    // eslint-disable-next-line no-unused-vars
    title,
    // eslint-disable-next-line no-unused-vars
    mls,
    // eslint-disable-next-line no-unused-vars
    licenses,
    // eslint-disable-next-line no-unused-vars
    ywh_ext_num,
    // eslint-disable-next-line no-unused-vars
    team_name,
    // eslint-disable-next-line no-unused-vars
    agent_type,
    // eslint-disable-next-line no-unused-vars
    cities_served,
    // eslint-disable-next-line no-unused-vars
    states_served,
    // eslint-disable-next-line no-unused-vars
    communities_served,
    // eslint-disable-next-line no-unused-vars
    office_address,
    // eslint-disable-next-line no-unused-vars
    compensation_plan,
    showingnew_identifier,
    subdomain,
    loan_officer,
    enable_subdomain,
  } = data;

  const handleChangeFiles = async (_, value, files) => {
    //silently upload to edit community route
    const result = await updateCommunityPhotos({
      community_id: value,
      photos: files,
    });
  };

  const handleSavePhoto = async () => {
    setCropLoading(true);
    try {
      const imageData = await getCroppedImg(imgRef.current, completedCrop);

      const { blob, base64Image } = imageData;
      setPreviewImage(base64Image);
      setData({ ...data, photo: blob });
      setShowEditPhoto(false);
    } catch (error) {
      console.log(error);
    } finally {
      setCropLoading(false);
    }
  };

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;

    setCrop(centerAspectCrop(width, height, 1));
  };

  useEffect(() => setActiveAgent(data), [data]);

  const handleSabmit = (e) => {
    e.preventDefault();
    handleSubmit(data);
  };

  return (
    <form onSubmit={handleSabmit} method="POST">
      <AgentPage>
        <Dialog open={showEditPhoto} onClose={() => setShowEditPhoto(false)} maxWidth="lg">
          {cropLoading ? (
            <CropLoading>
              <Loader />
            </CropLoading>
          ) : (
            <>
              <ReactCrop
                crop={crop}
                onChange={(_, percentCrop) => setCrop(percentCrop)}
                onComplete={(c) => setCompletedCrop(c)}
                aspect={1}
              >
                <Box
                  component="img"
                  src={previewImage}
                  width="100%"
                  ref={imgRef}
                  sx={{ mx: 'auto' }}
                  onLoad={onImageLoad}
                />
              </ReactCrop>
              <CropperButtons>
                <Button onClick={handleSavePhoto}>SAVE</Button>
              </CropperButtons>
            </>
          )}
        </Dialog>
        <AgentDetail>
          <UploadPhotoWrapper>
            {previewImage && !error ? (
              <>
                <img
                  style={{ objectFit: 'cover', objectPosition: 'top center' }}
                  src={previewImage?.includes('data') ? previewImage : AGENT_PROFILE_URL + agent.photo}
                  alt="Preview"
                  onClick={() => document.getElementById('photo').click()}
                  onMouseEnter={() => setShowUploadPhoto(true)}
                  onError={() => setError(true)}
                />
                {showUploadPhoto && (
                  <UploadPhotoIcon
                    onMouseLeave={() => setShowUploadPhoto(false)}
                    onClick={() => document.getElementById('photo').click()}
                    style={{ borderRadius: '50%', backgroundColor: 'rgb(0, 0, 0, .7)', position: 'absolute' }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none">
                      <path
                        d="M61.1975 43.347C60.2506 43.347 59.3424 43.7232 58.6728 44.3928C58.0033 45.0624 57.6271 45.9705 57.6271 46.9175V48.2743L52.3428 42.99C50.477 41.1389 47.9552 40.1002 45.3269 40.1002C42.6986 40.1002 40.1768 41.1389 38.311 42.99L35.8117 45.4893L26.957 36.6346C25.0651 34.8337 22.5531 33.8293 19.9411 33.8293C17.329 33.8293 14.8171 34.8337 12.9251 36.6346L7.64089 41.9189V21.9244C7.64089 20.9774 8.01706 20.0693 8.68664 19.3997C9.35623 18.7301 10.2644 18.3539 11.2113 18.3539H36.2044C37.1514 18.3539 38.0595 17.9778 38.7291 17.3082C39.3987 16.6386 39.7749 15.7304 39.7749 14.7835C39.7749 13.8366 39.3987 12.9284 38.7291 12.2588C38.0595 11.5892 37.1514 11.2131 36.2044 11.2131H11.2113C8.37051 11.2131 5.64604 12.3416 3.63728 14.3503C1.62851 16.3591 0.5 19.0836 0.5 21.9244V64.7697C0.5 67.6105 1.62851 70.335 3.63728 72.3438C5.64604 74.3525 8.37051 75.481 11.2113 75.481H54.0566C56.8975 75.481 59.6219 74.3525 61.6307 72.3438C63.6395 70.335 64.768 67.6105 64.768 64.7697V46.9175C64.768 45.9705 64.3918 45.0624 63.7222 44.3928C63.0526 43.7232 62.1445 43.347 61.1975 43.347ZM11.2113 68.3401C10.2644 68.3401 9.35623 67.964 8.68664 67.2944C8.01706 66.6248 7.64089 65.7166 7.64089 64.7697V52.0232L17.9952 41.6689C18.5197 41.1691 19.2165 40.8902 19.9411 40.8902C20.6656 40.8902 21.3624 41.1691 21.887 41.6689L33.2053 52.9872L48.5582 68.3401H11.2113ZM57.6271 64.7697C57.6219 65.4532 57.3966 66.1168 56.9844 66.662L40.8817 50.4879L43.381 47.9886C43.637 47.7274 43.9425 47.5198 44.2797 47.3781C44.6169 47.2364 44.979 47.1634 45.3448 47.1634C45.7105 47.1634 46.0726 47.2364 46.4098 47.3781C46.747 47.5198 47.0525 47.7274 47.3085 47.9886L57.6271 58.3786V64.7697ZM74.4439 12.2485L63.7325 1.53716C63.393 1.2121 62.9926 0.957296 62.5543 0.787363C61.685 0.430254 60.71 0.430254 59.8408 0.787363C59.4025 0.957296 59.0021 1.2121 58.6625 1.53716L47.9512 12.2485C47.2789 12.9208 46.9011 13.8327 46.9011 14.7835C46.9011 15.7343 47.2789 16.6462 47.9512 17.3185C48.6235 17.9908 49.5354 18.3685 50.4862 18.3685C51.437 18.3685 52.3489 17.9908 53.0212 17.3185L57.6271 12.6769V32.6357C57.6271 33.5826 58.0033 34.4908 58.6728 35.1604C59.3424 35.83 60.2506 36.2062 61.1975 36.2062C62.1445 36.2062 63.0526 35.83 63.7222 35.1604C64.3918 34.4908 64.768 33.5826 64.768 32.6357V12.6769L69.3738 17.3185C69.7058 17.6532 70.1007 17.9188 70.5357 18.1C70.9708 18.2813 71.4375 18.3746 71.9089 18.3746C72.3802 18.3746 72.8469 18.2813 73.282 18.1C73.7171 17.9188 74.1119 17.6532 74.4439 17.3185C74.7785 16.9866 75.0441 16.5917 75.2254 16.1566C75.4067 15.7215 75.5 15.2548 75.5 14.7835C75.5 14.3122 75.4067 13.8455 75.2254 13.4104C75.0441 12.9753 74.7785 12.5804 74.4439 12.2485Z"
                        fill="#A8A8A8"
                      />
                    </svg>
                    <h5>UPLOAD PHOTO</h5>
                  </UploadPhotoIcon>
                )}
              </>
            ) : (
              <UploadPhotoIcon onClick={() => document.getElementById('photo').click()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none">
                  <path
                    d="M61.1975 43.347C60.2506 43.347 59.3424 43.7232 58.6728 44.3928C58.0033 45.0624 57.6271 45.9705 57.6271 46.9175V48.2743L52.3428 42.99C50.477 41.1389 47.9552 40.1002 45.3269 40.1002C42.6986 40.1002 40.1768 41.1389 38.311 42.99L35.8117 45.4893L26.957 36.6346C25.0651 34.8337 22.5531 33.8293 19.9411 33.8293C17.329 33.8293 14.8171 34.8337 12.9251 36.6346L7.64089 41.9189V21.9244C7.64089 20.9774 8.01706 20.0693 8.68664 19.3997C9.35623 18.7301 10.2644 18.3539 11.2113 18.3539H36.2044C37.1514 18.3539 38.0595 17.9778 38.7291 17.3082C39.3987 16.6386 39.7749 15.7304 39.7749 14.7835C39.7749 13.8366 39.3987 12.9284 38.7291 12.2588C38.0595 11.5892 37.1514 11.2131 36.2044 11.2131H11.2113C8.37051 11.2131 5.64604 12.3416 3.63728 14.3503C1.62851 16.3591 0.5 19.0836 0.5 21.9244V64.7697C0.5 67.6105 1.62851 70.335 3.63728 72.3438C5.64604 74.3525 8.37051 75.481 11.2113 75.481H54.0566C56.8975 75.481 59.6219 74.3525 61.6307 72.3438C63.6395 70.335 64.768 67.6105 64.768 64.7697V46.9175C64.768 45.9705 64.3918 45.0624 63.7222 44.3928C63.0526 43.7232 62.1445 43.347 61.1975 43.347ZM11.2113 68.3401C10.2644 68.3401 9.35623 67.964 8.68664 67.2944C8.01706 66.6248 7.64089 65.7166 7.64089 64.7697V52.0232L17.9952 41.6689C18.5197 41.1691 19.2165 40.8902 19.9411 40.8902C20.6656 40.8902 21.3624 41.1691 21.887 41.6689L33.2053 52.9872L48.5582 68.3401H11.2113ZM57.6271 64.7697C57.6219 65.4532 57.3966 66.1168 56.9844 66.662L40.8817 50.4879L43.381 47.9886C43.637 47.7274 43.9425 47.5198 44.2797 47.3781C44.6169 47.2364 44.979 47.1634 45.3448 47.1634C45.7105 47.1634 46.0726 47.2364 46.4098 47.3781C46.747 47.5198 47.0525 47.7274 47.3085 47.9886L57.6271 58.3786V64.7697ZM74.4439 12.2485L63.7325 1.53716C63.393 1.2121 62.9926 0.957296 62.5543 0.787363C61.685 0.430254 60.71 0.430254 59.8408 0.787363C59.4025 0.957296 59.0021 1.2121 58.6625 1.53716L47.9512 12.2485C47.2789 12.9208 46.9011 13.8327 46.9011 14.7835C46.9011 15.7343 47.2789 16.6462 47.9512 17.3185C48.6235 17.9908 49.5354 18.3685 50.4862 18.3685C51.437 18.3685 52.3489 17.9908 53.0212 17.3185L57.6271 12.6769V32.6357C57.6271 33.5826 58.0033 34.4908 58.6728 35.1604C59.3424 35.83 60.2506 36.2062 61.1975 36.2062C62.1445 36.2062 63.0526 35.83 63.7222 35.1604C64.3918 34.4908 64.768 33.5826 64.768 32.6357V12.6769L69.3738 17.3185C69.7058 17.6532 70.1007 17.9188 70.5357 18.1C70.9708 18.2813 71.4375 18.3746 71.9089 18.3746C72.3802 18.3746 72.8469 18.2813 73.282 18.1C73.7171 17.9188 74.1119 17.6532 74.4439 17.3185C74.7785 16.9866 75.0441 16.5917 75.2254 16.1566C75.4067 15.7215 75.5 15.2548 75.5 14.7835C75.5 14.3122 75.4067 13.8455 75.2254 13.4104C75.0441 12.9753 74.7785 12.5804 74.4439 12.2485Z"
                    fill="#A8A8A8"
                  />
                </svg>
                <h5>UPLOAD PHOTO</h5>
              </UploadPhotoIcon>
            )}
            <InputFile name="photo" type="file" accept="image/*" id="photo" onChange={handleImageChange} />
          </UploadPhotoWrapper>
          <AgentInfoWrapper>
            {!editName && (
              <EditContainer>
                <AgentH1>
                  {first_name} {last_name}
                </AgentH1>
                <EditIcon onClick={() => setEditName(true)} />
              </EditContainer>
            )}
            {editName && (
              <AgentNameWrapper>
                <CloseIcon onClick={() => setEditName(false)} />
                <Input
                  className={errors.first_name && 'has-error'}
                  placeholder="First Name"
                  required
                  name="first_name"
                  value={first_name}
                  onChange={handleInputChange}
                />
                {errors.first_name && <FieldErrorMessage>{errors.first_name}</FieldErrorMessage>}
                <Input
                  className={errors.last_name && 'has-error'}
                  placeholder="Last Name"
                  required
                  name="last_name"
                  value={last_name}
                  onChange={handleInputChange}
                />
                {errors.last_name && <FieldErrorMessage>{errors.last_name}</FieldErrorMessage>}
              </AgentNameWrapper>
            )}
            <AgentDetailsWrapper>
              <AgentDetailsInput
                label="MLS #"
                name="mls"
                value={mls}
                onChange={handleInputChange}
                placeholder={'MLS Number'}
                multi={true}
                hasError={errors.mls}
              />
              {errors.mls && <FieldErrorMessage>{errors.mls}</FieldErrorMessage>}
              <AgentDetailsInput
                label="License #"
                name="licenses"
                value={licenses}
                onChange={handleInputChange}
                placeholder={'License Number'}
                multi={true}
                hasError={errors.licenses}
              />
              {errors.licenses && <FieldErrorMessage>{errors.licenses}</FieldErrorMessage>}
              <AgentDetailsInput
                label="Mobile #"
                name="mobile_phone"
                value={mobile_phone}
                onChange={handleInputChange}
                placeholder={'Mobile Number'}
                hasError={errors.mobile_phone}
              />
              {errors.mobile_phone && <FieldErrorMessage>{errors.mobile_phone}</FieldErrorMessage>}
              <AgentDetailsInput
                label="Extension #"
                name="ywh_ext_num"
                value={ywh_ext_num}
                onChange={handleInputChange}
                placeholder={'Extension Number'}
                hasError={errors.ywh_ext_num}
              />
              {errors.ywh_ext_num && <FieldErrorMessage>{errors.ywh_ext_num}</FieldErrorMessage>}
              <AgentDetailsInput
                label="NHS URL"
                name="showingnew_identifier"
                value={showingnew_identifier}
                onChange={handleInputChange}
                placeholder={'URL Identifier (New Home Source)'}
                hasError={errors.showingnew_identifier}
              />
              {errors.showingnew_identifier && <FieldErrorMessage>{errors.showingnew_identifier}</FieldErrorMessage>}
             {isAdmin  && <>
                <AgentDetailsInputGroup>
                  <label>Loan Officer</label>
                  <span>:</span>
                  <Select
                    name="loan_officer"
                    className='loan-officer-container'
                    classNamePrefix='loan-officer-select'
                    options={officers.map(o => { return {value: o.id, label: o.first_name + ' ' + o.last_name} })}
                    onChange={(option) =>  setData({
                      ...data,
                      ["loan_officer"]: option,
                    })}
                    value={loan_officer}
                  />
                </AgentDetailsInputGroup>
                <SwitchContainer>
                  <label>Enable Subdomain</label>
                  <span>:</span>
                  <Switch
                    value={enable_subdomain}
                    checked={enable_subdomain}
                    name="enable_subdomain"
                    onChange={(e) => handleSelectChange('enable_subdomain', e.target.checked)}
                  />
                </SwitchContainer> 
                {(enable_subdomain == 1 || enable_subdomain == true) && <AgentDetailsInput
                  label="Subdomain"
                  name="subdomain"
                  value={subdomain}
                  onChange={handleInputChange}
                  placeholder="Agent Subdomain"
                  hasError={errors.subdomain}
                />}
              </>
              }
            </AgentDetailsWrapper>
          </AgentInfoWrapper>
        </AgentDetail>

        <AgentDetailExtra>
          <AgentContactContainer>
            <AgentContactWrapper>
              <AgentContactListItem
                title="Brokerage"
                name="brokerage"
                value={brokerage}
                onChange={handleInputChange}
                icon="brokerage"
                hasError={errors.brokerage}
              />
              {errors.brokerage && <FieldErrorMessage>{errors.brokerage}</FieldErrorMessage>}
              <AgentContactListItem
                title="Company Phone"
                name="company_phone"
                value={company_phone}
                onChange={handleInputChange}
                icon="company-phone"
              />
              <AgentContactListItem
                title="Compensation Plan"
                name="compensation_plan"
                value={compensation_plan}
                onChange={handleInputChange}
                icon="compensation-plan"
              />
              <AgentContactListItem
                title="Team Name"
                name="team_name"
                value={team_name}
                onChange={handleInputChange}
                icon="team-name"
              />
              <AgentContactListItem
                title="Agent Type"
                name="agent_type"
                value={agent_type}
                onChange={handleInputChange}
                icon="agent-type"
              />
            </AgentContactWrapper>
          </AgentContactContainer>
          <AgentAdditionalDetailsContainer>
            <AgentOfficeAddress
              title="Office Address"
              name="office_address"
              value={office_address}
              onChange={handleInputChange}
            />
            <AgentCompanyWebsite company={company_website} personal={personal_website} onChange={handleInputChange} />
            <AgentCityStateServedContainer>
              <AgentCityStateServed
                title="state"
                name="states_served"
                values={states_served || []}
                onChange={handleSelectChange}
                description="Serving the following States"
              />
              {states_served && states_served.length > 0 && (
                <AgentCityStateServed
                  title="city"
                  name="cities_served"
                  values={cities_served}
                  params={states_served}
                  onChange={handleSelectChange}
                  description="Serving Cities and Surrounding Towns"
                />
              )}
              {cities_served && cities_served.length > 0 && (
                <AgentCityStateServed
                  title="community"
                  name="communities_served"
                  values={communities_served}
                  params={cities_served}
                  onChange={handleSelectChange}
                  description="Serving the following Communities"
                />
              )}
            </AgentCityStateServedContainer>
          </AgentAdditionalDetailsContainer>
        </AgentDetailExtra>

        <AgentDetailsBio
          title="Name"
          icon="bio-name"
          name="description"
          values={description}
          onChange={handleInputChange}
          subtitle="GET TO KNOW"
          type="text"
        />
        {communities_served && communities_served.length > 0 && (
          <AgentDetailsBio
            onChangeFiles={handleChangeFiles}
            title="COMMUNITY"
            icon="bio-community"
            subtitle="EXPLORE THE"
            type="gallery"
            communities={communities_served}
          />
        )}
        <AgentFooter isSubmitting={isSubmitting} />
      </AgentPage>
    </form>
  );
};

export default EditAgent;
